/*!
 * Combine multiple other providers into one 🥊  tko.provider.multi@4.0.0-alpha5c
 * (c) The Knockout.js Team - https://tko.io/
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */

import { Provider } from 'tko.provider';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var MultiProvider = /** @class */ (function (_super) {
    __extends(MultiProvider, _super);
    function MultiProvider(params) {
        if (params === void 0) { params = {}; }
        var _this = _super.call(this, params) || this;
        var providers = params.providers || [];
        _this.nodeTypeMap = {};
        _this.nodeTypes = [];
        _this.providers = [];
        providers.forEach(function (p) { return _this.addProvider(p); });
        return _this;
    }
    Object.defineProperty(MultiProvider.prototype, "FOR_NODE_TYPES", {
        get: function () { return this.nodeTypes; },
        enumerable: true,
        configurable: true
    });
    MultiProvider.prototype.setGlobals = function (globals) {
        __spread([this], this.providers).forEach(function (p) { return (p.globals = globals); });
    };
    MultiProvider.prototype.addProvider = function (provider) {
        var e_1, _a;
        this.providers.push(provider);
        provider.bindingHandlers = this.bindingHandlers;
        provider.globals = this.globals;
        var nodeTypeMap = this.nodeTypeMap;
        try {
            for (var _b = __values(provider.FOR_NODE_TYPES), _c = _b.next(); !_c.done; _c = _b.next()) {
                var nodeType = _c.value;
                if (!nodeTypeMap[nodeType]) {
                    nodeTypeMap[nodeType] = [];
                }
                nodeTypeMap[nodeType].push(provider);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.nodeTypes = Object.keys(this.nodeTypeMap).map(function (k) { return parseInt(k, 10); });
    };
    MultiProvider.prototype.providersFor = function (node) {
        return this.nodeTypeMap[node.nodeType] || [];
    };
    MultiProvider.prototype.nodeHasBindings = function (node) {
        return this.providersFor(node).some(function (p) { return p.nodeHasBindings(node); });
    };
    MultiProvider.prototype.preprocessNode = function (node) {
        var e_2, _a;
        try {
            for (var _b = __values(this.providersFor(node)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var provider = _c.value;
                var newNodes = provider.preprocessNode(node);
                if (newNodes) {
                    return newNodes;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    MultiProvider.prototype.enumerateProviderBindings = function (node, ctx) {
        var e_3, _a, e_4, _b, _c, _d, provider, bindings, _e, _f, _g, key, accessor, e_4_1, e_3_1;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _h.trys.push([0, 11, 12, 13]);
                    _c = __values(this.providersFor(node)), _d = _c.next();
                    _h.label = 1;
                case 1:
                    if (!!_d.done) return [3 /*break*/, 10];
                    provider = _d.value;
                    bindings = provider.getBindingAccessors(node, ctx) || {};
                    _h.label = 2;
                case 2:
                    _h.trys.push([2, 7, 8, 9]);
                    _e = __values(Object.entries(bindings || {})), _f = _e.next();
                    _h.label = 3;
                case 3:
                    if (!!_f.done) return [3 /*break*/, 6];
                    _g = __read(_f.value, 2), key = _g[0], accessor = _g[1];
                    return [4 /*yield*/, [key, accessor]];
                case 4:
                    _h.sent();
                    _h.label = 5;
                case 5:
                    _f = _e.next();
                    return [3 /*break*/, 3];
                case 6: return [3 /*break*/, 9];
                case 7:
                    e_4_1 = _h.sent();
                    e_4 = { error: e_4_1 };
                    return [3 /*break*/, 9];
                case 8:
                    try {
                        if (_f && !_f.done && (_b = _e["return"])) _b.call(_e);
                    }
                    finally { if (e_4) throw e_4.error; }
                    return [7 /*endfinally*/];
                case 9:
                    _d = _c.next();
                    return [3 /*break*/, 1];
                case 10: return [3 /*break*/, 13];
                case 11:
                    e_3_1 = _h.sent();
                    e_3 = { error: e_3_1 };
                    return [3 /*break*/, 13];
                case 12:
                    try {
                        if (_d && !_d.done && (_a = _c["return"])) _a.call(_c);
                    }
                    finally { if (e_3) throw e_3.error; }
                    return [7 /*endfinally*/];
                case 13: return [2 /*return*/];
            }
        });
    };
    MultiProvider.prototype.getBindingAccessors = function (node, ctx) {
        var e_5, _a;
        var bindings = {};
        try {
            for (var _b = __values(this.enumerateProviderBindings(node, ctx)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], accessor = _d[1];
                if (key in bindings) {
                    throw new Error("The binding \"" + key + "\" is duplicated by multiple providers");
                }
                bindings[key] = accessor;
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return bindings;
    };
    return MultiProvider;
}(Provider));

export { MultiProvider };
//# sourceMappingURL=tko.provider.multi.js.map
